export default {
  main: '#BC9C77',
  secondary: '#CA9896',
  contrastingColor: '#000000',
  priceColor: '#CA9896',
  entryBackground: '#000000',
  menuBackgroundColor: '#ffffff',
  menuTextColor: '#000000',
};
